import React from 'react'
import { useTranslation } from 'react-i18next';
import { rightArrow, subMenuHome, subMenuPartners, subMenuProjects, whyUs } from '../../../assets/images';


  const newsItems = [
    {
      id: 1,
      imgSrc: subMenuHome,
      title: 'İsitmə',
      description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq.',
    },
    {
      id: 2,
      imgSrc: subMenuPartners,
      title: 'Ventilyasiya',
      description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq.',
    },
    {
      id: 3,
      imgSrc: subMenuProjects,
      title: 'Soyutma, kondisionerləşdirmə',
      description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq.',
    },
    {
        id: 4,
        imgSrc: subMenuHome,
        title: 'Santexnika',
        description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq.',
      },
      {
        id: 5,
        imgSrc: subMenuPartners,
        title: 'Yanğınsöndürmə',
        description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq.',
      },
      {
        id: 6,
        imgSrc: subMenuProjects,
        title: 'Elektrik sistemləri',
        description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq.',
      },
      {
        id: 7,
        imgSrc: subMenuHome,
        title: 'Aşağı cərəyan',
         description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq.',
      },
      {
        id: 8,
        imgSrc: subMenuPartners,
        title: 'Avtomatlaşdırma sistemləri',
         description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq.',
      },
      {
        id: 9,
        imgSrc: subMenuProjects,
        title: 'Kanal sexi',
        description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq.',
      },
  ];

const CareersResourceItems = () => {


      const { t } = useTranslation();

  return (
    <div className='pt-[88px] md:pt-[104px] bg-[#FBFBFB]'>
        <div className='max-w-containerSm md:max-w-container mx-auto gap-5'>
        <div className='text-[#1C1C1C]'>
    <p className='mt-6'>İnsan kapitalı ən qiymətli sərvətimizdir. Uğurlarımızın arxasında yüksək ixtisaslı və peşəkar kadrlarımız dayanır. Çalışırıq ki, hər bir işçimizin potensialını tam qiymətləndirək, inkişafa daim açıq olan mühit yaradaq, karyera inkişaflarını dəstəkləyək.</p>
    <p className='text-[24px] font-medium mt-6'>Peşəkar İnkişaf</p>
    <p className='mt-6'>Biz inanırıq ki, davamlı inkişaf uğurlu karyeranın əsasıdır. Bu səbəbdən əməkdaşlarımıza müxtəlif təlimlər, seminarlar və sertifikatlaşdırma proqramları təklif edirik. Məqsədimiz komandamızın yeniliklərdən daim məlumatlı olması və inkişafları üçün təklif etdiyimiz imkanlardan düzgün istifadə etməsidir.</p>
    <p className='text-[24px] font-medium mt-6'>İşə Qəbul Prosesi</p>
    <p className='mt-6'>Dinamik, qabacıl  və innovativ şirkətdə karyera qurmaq istəyirsinizsə bizə qoşulmaq üçün müraciət edə bilərsiniz. Bizim işə qəbul prosesimiz şəffaf, obyektiv və ədalətlidir. Bizimlə işləmək istəyən namizədlər bilik və bacarıqlarına uyğun olaraq qiymətləndirilir və lazımi vəzifələrə yönləndirilir.</p>
    <p className='text-[24px] font-medium mt-6'>Müxtəliflik və Bərabərlik</p>
    <p className='mt-6'>Şirkətimizdə müxtəlifliyin və inklüzivliyin əhəmiyyətinə dərin hörmətlə yanaşırıq. İş mühitimizdə bərabər imkanlar yaratmaqla biz hər kəsə öz potensialını tam şəkildə reallaşdırmaq üçün şərait yaradırıq. Biz əməkdaşlarımızın bacarıqlarını və təcrübəsini qiymətləndiririk.</p>
    <p className='text-[24px] font-medium mt-6'>Mükafatlar və Loyallıq Proqramları</p>
    <p className='mt-6'>Şirkətimiz əməkdaşlarımızın zəhmətini və təşəbbüslərini yüksək qiymətləndirir. Komandamızın fəaliyyəti şirkətin ümumi uğuruna verdiyi töhfəyə görə dəyərləndirilir. Əməkdaşlarımız üçün xüsusi loyallıq proqramlarımız var. Bu proqramlar çərçivəsində əməkdaşlarımıza xüsusi mükafatlar və ya təlim imkanları təklif olunur.</p>
    
        </div>


    </div>
    </div>
  )
}

export default CareersResourceItems